<template>
  <div class="main-container">
    <div class="main-box">
      <div class="self-info-top">
        <div class="contentfill-top">
          <div class="top-fl">
            <p><img src="https://www.ttcdw.cn/p/uc/static/img/archives.f793f16.png"> <span>学习档案</span></p>
          </div>
        </div>
        <div class="contentfill-bottom">
          <div class="info-img"><img src="https://www.ttcdw.cn/p/uc/static/img/oneInchPhoto.48c3bd5.png"></div>
          <div class="info-right">
            <div class="text-left">
              <p class="name-txt">姓名：样衣一</p>
              <div class="self-left-txt">
                <div class="btn-edit"><a>查看</a></div>
              </div>
            </div>
            <div class="text-right">
              <p class="updateData-tip">每日凌晨更新前日统计数据</p>
              <div class="total-study-data" style="margin-bottom: 8px;">
                <div class="col-one"><img src="https://www.ttcdw.cn/p/uc/static/img/totalScore-icon.1109bee.png"></div>
                <div class="col-two">
                  <p class="word4">总成绩</p>
                  <p class="word5">0</p>
                </div>
              </div>
              <div class="total-study-data">
                <div class="col-one"><img src="https://www.ttcdw.cn/p/uc/static/img/totalCredit-icon.3063d07.png"></div>
                <div class="col-two">
                  <p class="word4">总学时</p>
                  <p class="word5">0.00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div element-loading-spinner="el-icon-loading" class="stage-data">
        <div>
          <div class="stage-part1">
            <div class="part1-title">
              <div class="top-fl">
                <p><img src="	https://www.ttcdw.cn/p/uc/static/img/stage-icon.b052b44.png"> <span>已完成报名，资格赛待开始</span></p>
              </div>
            </div>
            <div class="part1-content">
              <div class="content-f1">
                <div class="left-overview"><span class="overview-f1">学习总览</span>
                  <span class="overview-tip">统计数据每日凌晨更新，请您学习后第二天查看已完成、成绩、学时统计</span>
                </div>
                <div class="right-overview"><span>阶段成绩：</span> 0 <span>阶段学时：</span> 0.00
                </div>
              </div>
              <div class="content-table">
                <el-table :data="tableData" border style="width: 100%" :cell-style="{ 'text-align': 'center' }"
                  :header-cell-style="{ 'text-align': 'center', 'background-color': 'rgb(242, 242, 242)','color':'rgb(96, 98, 102)' }">
                  <el-table-column prop="date" label="考核项" width="180">
                  </el-table-column>
                  <el-table-column prop="name" label="考核要求" width="180">
                  </el-table-column>
                  <el-table-column prop="address" label="已完成">
                  </el-table-column>
                  <el-table-column prop="address" label="成绩">
                  </el-table-column>
                  <el-table-column prop="address" label="学时">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="stage-detail">
            <div class="detail-content">
              <div class="content-f1">
                <div class="left-overview"><span class="overview-f1">学习内容明细</span>
                  <span class="overview-tip">学习内容根据您的学习情况实时更新</span>
                </div>
              </div>
              <div class="empty-data">暂无数据</div>
            </div>
          </div>
        </div>
        <div class="el-loading-mask" style="display: none;">
          <div class="el-loading-spinner"><i class="el-icon-loading"></i><!----></div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  components: {

  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },
  computed: {
    activePath() {
      return this.$route.path;
    }
  },
  methods: {


  },

}
</script>
<style lang="scss" scoped>
.main-container {
  width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
  min-height: 60vh;

  .main-box {
    .self-info-top {
      border-radius: 7px;
      width: 100%;
      background: #FFFFFF;
      padding: 20px;
      overflow: hidden;

      .contentfill-top {
        border-bottom: 1px solid #F2F2F2;
        padding-bottom: 15px;

        .top-fl {
          p {
            color: #333;
            font-size: 13px;

            img {
              width: 24px;
              height: 24px;
            }

            span {
              vertical-align: 6px;
              font-size: 18px;
              font-weight: 600;
              margin-left: 10px;
            }

          }
        }
      }

      .contentfill-bottom {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .info-img {
          width: 100px;
          height: 134px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .info-right {
          flex: 1;
          display: flex;
          justify-content: space-between;
          margin-left: 15px;

          .text-left {
            .name-txt {
              font-size: 15px;
              font-weight: 500;
              line-height: 15px;
              margin-bottom: 20px;
            }

            .self-left-txt {
              margin-bottom: 15px;
              font-size: 14px;

              .btn-edit {
                width: 68px;
                height: 22px;
                border-radius: 10px;
                border: 1px solid #DEDEDE;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align: center;

                a {
                  font-size: 12px;
                  color: #999999;
                  cursor: pointer;
                }
              }
            }
          }

          .text-right {
            display: flex;
            flex-direction: column;
            align-items: center;

            .updateData-tip {
              font-weight: 400;
              color: red;
              line-height: 14px;
              font-size: 12px;
              margin-top: 11px;
              text-align: center;
              margin: 0 0 8px;
            }

            .total-study-data {
              padding: 10px 0 10px 20px;
              width: 140px;
              height: 52px;
              background: linear-gradient(90deg, #768ED5 0%, #4F69C4 100%);
              border-radius: 7px;

              .col-one {
                width: 32px;
                height: 32px;
                float: left;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .col-two {
                width: 78px;
                float: right;

                p:first-child {
                  font-size: 12px;
                  line-height: 16px;
                  font-weight: 200;
                  margin-bottom: 1px;
                }

                p:last-child {
                  font-size: 19px;
                  line-height: 16px;
                }

                p {
                  color: #FFFFFF;
                }
              }
            }
          }
        }
      }
    }

    .stage-data {
      width: 1200px;
      margin-top: 20px;

      .stage-part1 {
        background: #FFFFFF;
        border-radius: 7px;
        padding: 20px;
        overflow: hidden;

        .part1-title {
          border-bottom: 1px solid #F2F2F2;
          padding-bottom: 15px;

          .top-fl {
            p {
              color: #333;
              font-size: 13px;

              img {
                width: 24px;
                height: 24px;
              }

              span {
                vertical-align: 5px;
                font-size: 18px;
                font-weight: 600;
                margin-left: 10px;

              }
            }
          }
        }

        .part1-content {
          .content-f1 {
            overflow: hidden;
            padding: 20px 0;
            border-bottom: 1px solid #F2F2F2;

            .left-overview {
              float: left;

              .overview-f1 {
                font-size: 16px;
                font-weight: 600;
                line-height: 15px;
              }

              .overview-tip {
                margin-left: 10px;
                font-size: 12px;
                color: #666666;
                line-height: 12px;
              }
            }

            .right-overview {
              float: right;
              font-size: 15px;
              line-height: 15px;
              font-weight: 500;

              span {
                font-size: 15px;
                color: #666666;
              }
            }
          }

          .content-table {}
        }
      }

      .stage-detail {
        background: #FFFFFF;
        border-radius: 7px;
        padding: 20px;
        overflow: hidden;
        margin-top: 20px;

        .detail-content {
          .content-f1 {
            overflow: hidden;
            padding: 20px 0;
            border-bottom: 1px solid #F2F2F2;

            .left-overview {
              float: left;

              .overview-f1 {
                font-size: 16px;
                font-weight: 600;
                line-height: 15px;
              }

              .overview-tip {
                margin-left: 10px;
                font-size: 12px;
                color: #666666;
                line-height: 12px;
              }
            }
          }

          .empty-data {
            text-align: center;
            padding: 46px 0px;
            font-size: 16px;
            color: #666666;
          }
        }

        .empty-data {
          text-align: center;
          padding: 46px 0px;
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
}
</style>
